/**
 * Poofy Pay Theme — light regulated checkout aesthetic
 * Inter body, JetBrains Mono for monospace, cool neutral background
 */

const font = {
  url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap',
  family: "'Inter', system-ui, sans-serif",
};

export const theme = {
  colors: {
    background: '220 20% 97%',
    foreground: '213 25% 6%',
    card: '0 0% 100%',
    'card-foreground': '213 25% 6%',
    popover: '0 0% 100%',
    'popover-foreground': '213 25% 6%',
    primary: '224 100% 55%',
    'primary-foreground': '0 0% 100%',
    secondary: '220 14% 95%',
    'secondary-foreground': '213 25% 6%',
    muted: '220 14% 95%',
    'muted-foreground': '215 14% 35%',
    accent: '163 83% 25%',
    'accent-foreground': '0 0% 100%',
    destructive: '3 67% 40%',
    'destructive-foreground': '0 0% 100%',
    border: '218 14% 90%',
    input: '218 14% 90%',
    ring: '224 100% 55%',
    link: '224 100% 55%',
    'link-hover': '224 100% 45%',
    button: '224 100% 55%',
    'button-foreground': '0 0% 100%',
    'button-border': '224 100% 50%',
    'button-hover': '224 100% 48%',
    'button-hover-foreground': '0 0% 100%',
    'button-hover-border': '224 100% 42%',
    'button-ring': '224 100% 55%',
    'chart-1': '224 100% 55%',
    'chart-2': '163 83% 25%',
    'chart-3': '30 68% 42%',
    'chart-4': '280 65% 50%',
    'chart-5': '340 75% 50%',
    'sidebar-background': '220 20% 97%',
    'sidebar-foreground': '213 25% 6%',
    'sidebar-primary': '224 100% 55%',
    'sidebar-primary-foreground': '0 0% 100%',
    'sidebar-accent': '220 14% 95%',
    'sidebar-accent-foreground': '213 25% 6%',
    'sidebar-border': '218 14% 90%',
    'sidebar-ring': '224 100% 55%',
  },
  font,
  radius: '8px',
};
